import React from "react";
import MenuItem from "../MenuItem";
import { SubContent } from "../../components/Layout";
import IcDescricao from "../Svg/IcDescricao";
import IcFormando from "../Svg/IcFormando";
import IcReport from "../Svg/IcReport";
import IcEditar from "../Svg/IcEditar";
import IcCalendario from "../Svg/IcCalendario";
import IcAtendimento from "../Svg/IcAtendimento";
import IcClip from "../Svg/IcClip";
import IcBox from "../Svg/IcBox";
import IcBarCode from "../Svg/IcBarCode";
import IcFeito from "../Svg/IcFeito";
import IcConvite from "../Svg/IcConvite";

export default function SideBarMenuGroup({ commercialId }) {
  return (
    <SubContent className="p-0">
      <MenuItem icon={<IcDescricao />} href={`/groups/${commercialId}/registrationdata`}>
        Dados Gerais
      </MenuItem>
      <MenuItem icon={<IcFormando />} href={`/groups/${commercialId}/graduate`}>
        Formandos
      </MenuItem>
      <MenuItem icon={<IcReport />} href={`/groups/${commercialId}/costs`}>
        Planilha de Custos
      </MenuItem>
      <MenuItem icon={<IcConvite />} href={`/groups/${commercialId}/invites`}>
        Convites e Ingressos
      </MenuItem>
      <MenuItem icon={<IcEditar />} href={`/groups/${commercialId}/draft`}>
        Rascunho de Orçamento
      </MenuItem>
      <MenuItem icon={<IcCalendario />} href={`/groups/${commercialId}/calendar`}>
        Calendário
      </MenuItem>
      <MenuItem icon={<IcAtendimento />} href={`/groups/${commercialId}/attendance`}>
        Atendimento
      </MenuItem>
      <MenuItem icon={<IcClip />} href={`/groups/${commercialId}/files`}>
        Arquivos
      </MenuItem>
      <MenuItem icon={<IcBox />} href={`/groups/${commercialId}/products`}>
        Loja Virtual
      </MenuItem>
      <MenuItem icon={<IcBarCode />} href={`/groups/${commercialId}/charges`}>
        Cobrança Extra
      </MenuItem>
      <MenuItem icon={<IcFeito />} href={`/groups/${commercialId}/survey`}>
        Enquetes
      </MenuItem>
    </SubContent>
  );
}
